// Site-wide data: services, projects, panels, company info
// All content in Croatian as required

export const COMPANY = {
  name: "Electris d.o.o.",
  family: "Obitelj Jalšovec",
  foundedYear: 1950,
  city: "Varaždin",
  region: "Varaždin i okolica",
  address: "Kučanska 14, 42000 Varaždin",
  hours: "Pon — Pet · 07:00 – 15:00",
  contacts: [
    {
      role: "Direktor",
      name: "Nikola Jalšovec",
      phone: "091 892 8005",
      phoneIntl: "+385918928005",
      email: "nikola.jalsovec@gmail.com",
    },
    {
      role: "Voditelj projekata",
      name: "Jurica Horvat",
      phone: "095 730 2920",
      phoneIntl: "+385957302920",
      email: "juricahorvat20@gmail.com",
    },
    {
      role: "Voditelj projekata",
      name: "Ivica Benković",
      phone: "099 518 4630",
      phoneIntl: "+385995184630",
      email: "ivicabenkovic@gmail.com",
    },
    {
      role: "Voditelj projekata",
      name: "Ivan Cindori",
      phone: "095 771 7276",
      phoneIntl: "+385957717276",
      email: "cindori75@gmail.com",
    },
  ],
};

export const SERVICES = [
  {
    title: "Elektroinstalacije",
    desc: "Kompletne energetske i jake strujne instalacije za poslovne, stambene i komercijalne objekte.",
    image: "/slike%20usluga/slike%20usluga/elektroinstalacije%201.jpg",
  },
  {
    title: "Izrada elektro razdjelnika",
    desc: "Shemiranje i montaža energetskih elektro razdjelnika prema projektnoj dokumentaciji.",
    image: "/slike%20usluga/slike%20usluga/izrada%20elektro%20energetskih%20razdijelnika%202.jpg",
  },
  {
    title: "Prodaja i montaža rasvjete",
    desc: "Profesionalna ugradnja unutarnje, vanjske i DALI sustava rasvjete s vrhunskim komponentama.",
    image: "/slike%20usluga/slike%20usluga/prodaja%20i%20montaza%20rasvijetnih%20tijela%203.jpg",
  },
  {
    title: "Solarne elektrane",
    desc: "Projektiranje i izgradnja solarnih elektrana za kućanstva i poslovne objekte.",
    image: "/slike%20usluga/slike%20usluga/solarne%20elektrane%204.jpg",
  },
  {
    title: "Komunikacijske instalacije",
    desc: "Strukturno kabliranje, mrežne instalacije i televizijski sustavi za poslovne i stambene objekte.",
    image: "/slike%20usluga/slike%20usluga/komunikacijeske%20i%20televizijske%20instalacije%205.jpeg",
  },
  {
    title: "Vatrodojava i odimljavanje",
    desc: "Vatrodojavni sustavi i instalacije sustava odimljavanja za maksimalnu sigurnost objekta.",
    image: "/slike%20usluga/slike%20usluga/vatrodojavne%20instalacije%20te%20instalacije%20odimljavanja%206.jpg",
  },
  {
    title: "Gromobranske instalacije",
    desc: "Kompletne gromobranske instalacije i sustavi izjednačenja potencijala za zaštitu objekta.",
    image: "/slike%20usluga/slike%20usluga/gromobranske%20instalacije%207.webp",
  },
  {
    title: "Električna podna grijanja",
    desc: "Ugradnja električnih podnih grijanja s preciznim sustavom regulacije temperature.",
    image: "/slike%20usluga/slike%20usluga/elektricna%20podna%20grijanja%208.jpeg",
  },
  {
    title: "Zemljani radovi",
    desc: "Iskopi i polaganje energetskih kabela, uzemljenja i komunalne infrastrukture.",
    image: "/slike%20usluga/slike%20usluga/zemljani%20radovi%209.jpg",
  },
];

export const PROJECTS = [
  {
    id: "centar-predinkubacija",
    title: "Centar za predinkubaciju",
    location: "Centar Varaždina · uz Vilu Oršić",
    short:
      "Više od 1.200 m² najsuvremenijeg prostora FOI-ja — prvi sustavni predinkubacijski centar u Hrvatskoj.",
    description:
      "Smješten u samom središtu Varaždina, uz povijesnu Vilu Oršić, novi Centar prostirat će se na više od 1.200 m² najsuvremenije opremljenog prostora. FOI ovim iskorakom postavlja nove standarde u povezivanju znanosti, poduzetništva i industrije, postajući prvi fakultet u zemlji koji sustavno ulaže u razvoj predinkubacije — najranije i najosjetljivije faze razvoja poduzetničkih ideja.",
    bullets: [
      "Shemiranje elektro ormara",
      "Instalacija pametne rasvjete",
      "Izvođenje elektro instalacija",
      "Izvođenje komunikacijske mreže",
      "Gromobranske instalacije",
      "Instalacije vatrodojave",
      "Instalacije sustava za odimljavanje",
    ],
    cover: "/projects/centar-predinkubacija/1.jpg",
    images: [
      "/projects/centar-predinkubacija/1.jpg",
      "/projects/centar-predinkubacija/2.jpg",
    ],
  },
  {
    id: "green-living",
    title: "Green Living",
    location: "Varaždin",
    short:
      "Nova zelena lokacija — 237 stanova i 309 garažnih mjesta.",
    description:
      "Green Living — nova zelena lokacija koja sadržava 237 stanova, te garažu od čak 309 parking mjesta. Izvedeni su svi elektroinstalacijski radovi prema važećim normama i visokim stambenim standardima.",
    bullets: [
      "Shemiranje elektro ormara",
      "Izvođenje elektro instalacija",
      "Gromobranske instalacije",
      "Instalacije vatrodojave",
      "Instalacije sustava za odimljavanje",
    ],
    cover: "/projects/green-living/1.jpg",
    images: ["/projects/green-living/1.jpg"],
  },
  {
    id: "grabanice-4",
    title: "Grabanice 4",
    location: "Varaždin · Marlex Invest",
    short:
      "Stambena zgrada s 78 stanova i podzemnom garažom (Marlex Invest).",
    description:
      "Na stambenoj zgradi s 78 stanova i podzemnom garažom, smještenoj u brzorastućem kvartu Grabanice u Varaždinu, pod investitorom Marlex Invest, izvedeni su svi elektroinstalacijski radovi.",
    bullets: [
      "Shemiranje elektro ormara",
      "Izvođenje elektro instalacija",
      "Gromobranske instalacije",
      "Instalacije vatrodojave",
      "Instalacije sustava za odimljavanje",
    ],
    cover: "/projects/grabanice-4/1.jpg",
    images: ["/projects/grabanice-4/1.jpg"],
  },
  {
    id: "pos-stanovi-2",
    title: "POS 2",
    location: "Ulica I. N. Petrovića, Varaždin",
    short: "25 stanova s podzemnom garažom (Grad Varaždin · ZTB / Euromonsan).",
    description:
      "Na stambenoj zgradi s 25 stanova te podzemnom garažom smještenoj u Ulici Ivana Nepomuka Petrovića, pod investicijom Grada Varaždina uz zajednicu ponuditelja ZTB gradnja d.o.o te Euromonsan, izvedeni su svi elektroinstalacijski radovi.",
    bullets: [
      "Shemiranje elektro ormara",
      "Izvođenje elektro instalacija",
      "Gromobranske instalacije",
      "Montaža rasvjetnih tijela",
      "Instalacije sustava za odimljavanje",
    ],
    cover: "/projects/pos-2/1.jpg",
    images: ["/projects/pos-2/1.jpg"],
  },
  {
    id: "pos-stanovi-3",
    title: "POS 3",
    location: "Ulica I. N. Petrovića, Varaždin",
    short: "25 stanova s podzemnom garažom (Grad Varaždin · ZTB / Euromonsan).",
    description:
      "Na stambenoj zgradi s 25 stanova te podzemnom garažom smještenoj u Ulici Ivana Nepomuka Petrovića, pod investicijom Grada Varaždina uz zajednicu ponuditelja ZTB gradnja d.o.o te Euromonsan, izvedeni su svi elektroinstalacijski radovi.",
    bullets: [
      "Shemiranje elektro ormara",
      "Izvođenje elektro instalacija",
      "Gromobranske instalacije",
      "Montaža rasvjetnih tijela",
      "Instalacije sustava za odimljavanje",
    ],
    cover: "/projects/pos-3/1.jpg",
    images: ["/projects/pos-3/1.jpg"],
  },
  {
    id: "green-park",
    title: "Trgovački Centar Green Park",
    location: "Donji Kneginec",
    short:
      "Parcela od 27.000 m², bruto objekt 5.600 m². Svi elektroinstalacijski radovi.",
    description:
      "Na projektu „Green Park\" u Donjem Knegincu, smještenom na parceli od 27.000 kvadratnih metara s bruto površinom objekta od 5.600 kvadratnih metara, izvršeni su svi elektroinstalacijski radovi.",
    bullets: [
      "Shemiranje i montaža elektro ormara",
      "Energetske instalacije",
      "Elektroinstalacije strojarstva",
      "Vatrodojava",
      "Instalacija sustava odimljavanja",
    ],
    cover:
      "/images/trgovacki%20centar%20green%20park/1000018498.jpg",
    images: [
      "/images/trgovacki%20centar%20green%20park/1000018498.jpg",
      "/images/trgovacki%20centar%20green%20park/1000017275.jpg",
      "/images/trgovacki%20centar%20green%20park/1000017278.jpg",
      "/images/trgovacki%20centar%20green%20park/1000017279.jpg",
      "/images/trgovacki%20centar%20green%20park/1000017280.jpg",
    ],
  },
  {
    id: "izi-energy",
    title: "Bezposadna benzinska postaja",
    location: "IZI ENERGY",
    short:
      "Samoposlužna autopraonica, benzinska postaja i punionice električnih automobila.",
    description:
      "Izvođenje elektroinstalacija na objektu samoposlužne autopraonice, bezposadne benzinske postaje IZI ENERGY te punionice električnih automobila.",
    bullets: [
      "Energetske instalacije",
      "Vanjska rasvjeta",
      "Punionice električnih automobila",
      "Solarne elektrane",
      "Podno grijanje",
    ],
    cover:
      "/images/bezposadna%20benzinska%20postaja%20i%20samoposluzna%20autopraonica/8-min.jpg",
    images: [
      "/images/bezposadna%20benzinska%20postaja%20i%20samoposluzna%20autopraonica/8-min.jpg",
      "/images/bezposadna%20benzinska%20postaja%20i%20samoposluzna%20autopraonica/1000017268-min.jpg",
      "/images/bezposadna%20benzinska%20postaja%20i%20samoposluzna%20autopraonica/1000017497-min.jpg",
      "/images/bezposadna%20benzinska%20postaja%20i%20samoposluzna%20autopraonica/1000017270-min.jpg",
      "/images/bezposadna%20benzinska%20postaja%20i%20samoposluzna%20autopraonica/1000017282-min.jpg",
      "/images/bezposadna%20benzinska%20postaja%20i%20samoposluzna%20autopraonica/1000017754(1)-min.jpg",
      "/images/bezposadna%20benzinska%20postaja%20i%20samoposluzna%20autopraonica/1000017271-min.jpg",
      "/images/bezposadna%20benzinska%20postaja%20i%20samoposluzna%20autopraonica/1000015064-min.jpg",
      "/images/bezposadna%20benzinska%20postaja%20i%20samoposluzna%20autopraonica/1000019020-min.jpg",
    ],
  },
  {
    id: "vtc",
    title: "VTC",
    location: "Varaždin",
    short: "Prenamjena zgrade VTC u suvremeni stambeni objekt.",
    description:
      "U blizini centra grada, izvedeni su elektroinstalacijski radovi na postojećoj zgradi VTC, koja je prenamijenjena u stambeni objekt.",
    bullets: [
      "Shemiranje elektro ormara",
      "Gromobranske instalacije",
      "Elektro-strojarske instalacije",
      "Sustavi vatrodojave",
      "Plinodojavne instalacije",
    ],
    cover: "/images/vtc/vtc%201.jpg",
    images: [
      "/images/vtc/vtc%201.jpg",
      "/images/vtc/1000018610.jpg",
      "/images/vtc/1000018608.jpg",
      "/images/vtc/1000018609.jpg",
      "/images/vtc/1000018611.jpg",
      "/images/vtc/1000018607.jpg",
    ],
  },
  {
    id: "reca",
    title: "RECA",
    location: "I. Brlić-Mažuranić 17, Varaždin",
    short:
      "Poslovni objekt RECA Ltd. — energetske instalacije i shemiranje elektro ormara.",
    description:
      "Na lokaciji Ivane Brlić-Mažuranić 17, 42000 Varaždin, izvršeni su elektroinstalacijski radovi na poslovnom objektu tvrtke RECA Ltd. Naša stručna ekipa izvodila je sve potrebne energetske instalacije, uključujući shematsko povezivanje elektro ormara, elektroinstalacije za strojarstvo, te ostale elektroinstalacijske radove.",
    bullets: [
      "Energetske instalacije",
      "Shematsko povezivanje elektro ormara",
      "Elektroinstalacije za strojarstvo",
    ],
    cover: "/images/reca/reca%204.jpg",
    images: [
      "/images/reca/reca%204.jpg",
      "/images/reca/reca%202.jpg",
      "/images/reca/reca%203.jpg",
      "/images/reca/reca%201.jpg",
    ],
  },
  {
    id: "croatia-poliklinika",
    title: "Croatia osiguranje — Poliklinika",
    location: "Varaždin",
    short:
      "Najmoderniji objekt poliklinike na 1.000 m². Instalacije za RTG i mamografski uređaj.",
    description:
      "Na najmodernijem objektu Poliklinike Croatia osiguranje u Varaždinu, smještenom na bruto površini od 1.000 četvornih metara, naša ekipa je aktivno sudjelovala u izvođenju elektroinstalacijskih radova.",
    bullets: [
      "Shemiranje elektro ormara",
      "Izvođenje elektroinstalacija",
      "Instalacije za RTG uređaje",
      "Instalacije za mamografski uređaj",
      "Ugradnja podnih kanala u glazuru",
    ],
    cover:
      "/images/croatia%20osiguranje%20poliklinika/croatia%20osiguranje%20polilinika%201,2.jpg",
    images: [
      "/images/croatia%20osiguranje%20poliklinika/1000020372.jpg",
      "/images/croatia%20osiguranje%20poliklinika/croatia%20osiguranje%20poliklinika%201,1.jpg",
      "/images/croatia%20osiguranje%20poliklinika/croatia%20osiguranje%20polilinika%201,2.jpg",
    ],
  },
  {
    id: "croatia-poslovna",
    title: "Croatia osiguranje — Poslovni prostor",
    location: "Varaždin",
    short:
      "Četiri poslovna prostora na 1.000 m². Kompletni elektroinstalacijski radovi.",
    description:
      "Na projektu poslovnih prostora Croatia osiguranje u Varaždinu, smještenih na bruto površini od 1.000 četvornih metara, izvedeni su svi elektroinstalacijski radovi za četiri poslovna prostora.",
    bullets: [
      "Shemiranje elektro ormara",
      "Energetske instalacije",
      "Elektroinstalacije strojarstva",
      "Instalacije vatrodojave",
      "Komunikacijske instalacije",
    ],
    cover: "/images/cro%20osig%20poslovna/1000018605.jpg",
    images: [
      "/images/cro%20osig%20poslovna/1000018604.jpg",
      "/images/cro%20osig%20poslovna/1000018605.jpg",
      "/images/cro%20osig%20poslovna/1000018606.jpg",
    ],
  },
  {
    id: "vrtic-orehovica",
    title: "Dječji vrtić Orehovica",
    location: "Orehovica",
    short: "Četiri vrtićke i dvije jasličke skupine — sigurnost i udobnost.",
    description:
      "Izvođenje elektroinstalacija na dječjem vrtiću Orehovica, koji obuhvaća četiri vrtićke i dvije jasličke skupine, s ciljem osiguravanja funkcionalnosti, sigurnosti i udobnosti prostora za djecu i odgojitelje.",
    bullets: [
      "Energetske instalacije",
      "Instalacije vatrodojave",
      "Komunikacijske instalacije",
      "Shemiranje elektro ormara",
      "Zemljani radovi",
      "Gromobranske instalacije",
    ],
    cover:
      "/images/djecji%20vrtic%20orehovica/1000018884.jpg",
    images: [
      "/images/djecji%20vrtic%20orehovica/1000018882.jpg",
      "/images/djecji%20vrtic%20orehovica/1000018885.jpg",
      "/images/djecji%20vrtic%20orehovica/1000018888.jpg",
      "/images/djecji%20vrtic%20orehovica/1000018889.jpg",
      "/images/djecji%20vrtic%20orehovica/1000018884.jpg",
    ],
  },
  {
    id: "grabanice-marlex",
    title: "Grabanice 1",
    location: "Varaždin · Marlex Invest",
    short: "Stambena zgrada s 40 stanova i 19 garaža (Marlex Invest).",
    description:
      "Na stambenoj zgradi s 40 stanova i 19 garaža, smještenoj u brzorastućem kvartu Grabanice u Varaždinu, pod investicijom Marlex Invest, izvedeni su svi elektroinstalacijski radovi.",
    bullets: [
      "Shemiranje elektro ormara",
      "Izvođenje elektro instalacija",
      "Gromobranske instalacije",
      "Instalacije sustava za odimljavanje",
    ],
    cover:
      "/images/stambena%20zgrada%20u%20kvartu%20grabanice%20-%20marlex/grabanice%20marlex%201.jpg",
    images: [
      "/images/stambena%20zgrada%20u%20kvartu%20grabanice%20-%20marlex/grabanice%20marlex%201,1.jpg",
      "/images/stambena%20zgrada%20u%20kvartu%20grabanice%20-%20marlex/grabanice%20marlex%201.jpg",
      "/images/stambena%20zgrada%20u%20kvartu%20grabanice%20-%20marlex/1000018950.jpg",
      "/images/stambena%20zgrada%20u%20kvartu%20grabanice%20-%20marlex/1000018951.jpg",
    ],
  },
  {
    id: "grabanice-zeta",
    title: "Grabanice 2",
    location: "Varaždin · Zeta-Project",
    short: "Stambena zgrada s 40 stanova i 19 garaža (Zeta-Project).",
    description:
      "Na stambenoj zgradi s 40 stanova i 19 garaža, smještenoj u brzorastućem kvartu Grabanice u Varaždinu, pod investicijom Zeta-Project, izvedeni su svi elektroinstalacijski radovi.",
    bullets: [
      "Shemiranje elektro ormara",
      "Izvođenje elektro instalacija",
      "Gromobranske instalacije",
      "Instalacije sustava za odimljavanje",
    ],
    cover:
      "/images/stambena%20zgrada%20u%20kvartu%20grabanice%20-%20zeta%20project/grabanice%20zeta%20project%201.jpg",
    images: [
      "/images/stambena%20zgrada%20u%20kvartu%20grabanice%20-%20zeta%20project/grabanice%20zeta%20project%201.jpg",
      "/images/stambena%20zgrada%20u%20kvartu%20grabanice%20-%20zeta%20project/1000018948.jpg",
      "/images/stambena%20zgrada%20u%20kvartu%20grabanice%20-%20zeta%20project/1000018947.jpg",
      "/images/stambena%20zgrada%20u%20kvartu%20grabanice%20-%20zeta%20project/1000018949.jpg",
    ],
  },
  {
    id: "grabanice-3",
    title: "Grabanice 3",
    location: "Varaždin",
    short: "78 stanova s podzemnom garažom (Marlex Invest).",
    description:
      "Na stambenoj zgradi s 78 stanova i podzemnom garažom, smještenoj u brzorastućem kvartu Grabanice u Varaždinu, pod investitorom Marlex Invest, izvedeni su svi elektroinstalacijski radovi.",
    bullets: [
      "Shemiranje elektro ormara",
      "Izvođenje elektro instalacija",
      "Gromobranske instalacije",
      "Instalacije vatrodojave",
      "Instalacije sustava za odimljavanje",
    ],
    cover: "/images/grabanice%203/05.jpg",
    images: [
      "/images/grabanice%203/05.jpg",
      "/images/grabanice%203/08.jpg",
    ],
  },
  {
    id: "ive-rezeka",
    title: "Ive Režeka 1",
    location: "Varaždin",
    short: "Gromobranska instalacija krova zgrade u sklopu energetske obnove.",
    description:
      "Na lokaciji Ulica Ive Režeka izvodili smo prilikom energetske obnove gromobransku instalaciju krova zgrade.",
    bullets: ["Gromobranska instalacija krova", "Energetska obnova"],
    cover: "/images/ive%20rezeka%20i/1000034693.jpg",
    images: [
      "/images/ive%20rezeka%20i/1000034693.jpg",
      "/images/ive%20rezeka%20i/1000034694.jpg",
    ],
  },
  {
    id: "pos-stanovi",
    title: "POS 1",
    location: "Ulica I. N. Petrovića, Varaždin",
    short: "30 stanova s podzemnom garažom (Grad Varaždin · ZTB / Euromonsan).",
    description:
      "Na stambenoj zgradi s 30 stanova te podzemnom garažom smještenoj u Ulici Ivana Nepomuka Petrovića, pod investicijom Grada Varaždina uz zajednicu ponuditelja ZTB gradnja d.o.o te Euromonsan, izvedeni su svi elektroinstalacijski radovi.",
    bullets: [
      "Shemiranje elektro ormara",
      "Izvođenje elektro instalacija",
      "Gromobranske instalacije",
      "Montaža rasvjetnih tijela",
      "Instalacije sustava za odimljavanje",
    ],
    cover:
      "/images/pos%20stanovi/pos-stanovi-nepomuk-ivan-foto-grad-vara-3_67779a183f1ab.jpg",
    images: [
      "/images/pos%20stanovi/pos-stanovi-nepomuk-ivan-foto-grad-vara-3_67779a183f1ab.jpg",
      "/images/pos%20stanovi/1000034691.jpg",
      "/images/pos%20stanovi/1000034688.jpg",
      "/images/pos%20stanovi/1000034689.jpg",
      "/images/pos%20stanovi/1000034690.jpg",
    ],
  },
  {
    id: "pretovarna",
    title: "Pretovarna postaja",
    location: "Poljana Biškupečka",
    short: "Početak izvedbe elektro instalacija svih vrsta.",
    description:
      "Naš tim je započeo izvedbu elektro instalacija svih vrsta na pretovarnoj postaji Poljana Biškupečka.",
    bullets: ["Elektroinstalacije svih vrsta"],
    cover:
      "/images/pretovarna%20postaja/pretovarna-stanica-varazdin-2025-06-03-0004.jpg",
    images: [
      "/images/pretovarna%20postaja/pretovarna-stanica-varazdin-2025-06-03-0004.jpg",
      "/images/pretovarna%20postaja/20250812_124511.jpg",
    ],
  },
  {
    id: "varazdinske-toplice",
    title: "Varaždinske Toplice",
    location: "Varaždinske Toplice",
    short:
      "Pametne instalacije u dječjem vrtiću. DALI rasvjeta, solarni paneli u crvenom tonu.",
    description:
      "U Varaždinskim Toplicama započinjemo s izvedbom najmodernijih pametnih instalacija u dječjem vrtiću. Objekt će biti opremljen naprednim DALI sustavom rasvjete, dok će se na krovu nalaziti solarni paneli u crvenoj boji koji će izgledom podsjećati na tradicionalni crijep.",
    bullets: [
      "Elektroenergetske instalacije",
      "Instalacije slabe struje",
      "Vatrodojava",
      "Solarna elektrana",
      "DALI rasvjeta",
      "Gromobranska instalacija",
    ],
    cover:
      "/images/varazdinske%20toplice/vz-20toplice-20-20djecji-20vrtic-20-285-29_67e6e09c44569_860xr.jpg",
    images: [
      "/images/varazdinske%20toplice/vz-20toplice-20-20djecji-20vrtic-20-285-29_67e6e09c44569_860xr.jpg",
      "/images/varazdinske%20toplice/vz-20toplice-20-20djecji-20vrtic-20-283-29_67e6e09bc4100_860xr.jpg",
      "/images/varazdinske%20toplice/vz-20toplice-20-20djecji-20vrtic-20-282-29_67e6e09cb3fb9_860xr.jpg",
    ],
  },
  {
    id: "vila-novalja",
    title: "Vila Novalja",
    location: "Novalja",
    short: "Moderna vila od 800 m² — kompletni elektroinstalacijski radovi.",
    description:
      "Na modernoj vili od 800 kvadrata u Novalji, izvedeni su svi elektroinstalacijski radovi.",
    bullets: [
      "Shemiranje elektro ormara",
      "Izvođenje elektro instalacija",
      "Gromobranske instalacije",
      "Instalacije slabe struje",
      "Instalacije sustava za odimljavanje",
    ],
    cover: "/images/vila%20novalja/20250507_125505.jpg",
    images: [
      "/images/vila%20novalja/20250507_125505.jpg",
      "/images/vila%20novalja/20250507_125515.jpg",
      "/images/vila%20novalja/20250507_125451.jpg",
    ],
  },
];

// Display order for the Projects section. IDs are resolved against PROJECTS above.
export const PROJECT_ORDER = [
  "centar-predinkubacija",
  "green-living",
  "pretovarna",
  "varazdinske-toplice",
  "vtc",
  "green-park",
  "grabanice-marlex",
  "grabanice-zeta",
  "grabanice-3",
  "grabanice-4",
  "pos-stanovi",
  "pos-stanovi-2",
  "pos-stanovi-3",
  "reca",
  "croatia-poliklinika",
  "croatia-poslovna",
  "vrtic-orehovica",
  "ive-rezeka",
  "vila-novalja",
  "izi-energy",
];

export const PANELS = [
  "/panels/ormari-1.jpeg",
  "/panels/ormari-2.jpeg",
  "/slike%20elektro%20razdjelnika/20240926_073149.jpg",
  "/slike%20elektro%20razdjelnika/20241008_134657.jpg",
  "/slike%20elektro%20razdjelnika/20230915_123848.jpg",
  "/slike%20elektro%20razdjelnika/20230915_123603.jpg",
  "/slike%20elektro%20razdjelnika/1000020372.jpg",
  "/slike%20elektro%20razdjelnika/20240621_082140.jpg",
  "/slike%20elektro%20razdjelnika/20231017_083920.jpg",
  "/images/ormari/20250514_130737.jpg",
  "/images/ormari/20250526_115206.jpg",
  "/images/ormari/20250813_081553.jpg",
];

export const HERO_BG =
  "https://static.prod-images.emergentagent.com/jobs/31dece86-4a04-4bda-b3d3-8c5419ff027a/images/42d5eed6252f05017401dcbd720521f5d140dea4b00afbe256e3f2b8cd34dbcd.png";

export const ABOUT_IMG =
  "https://static.prod-images.emergentagent.com/jobs/31dece86-4a04-4bda-b3d3-8c5419ff027a/images/0c7292751ec632aefa9227029efbf4f9a0dd8adf0bca8075c370d99b28814ea9.png";
